import { AbstractControl, FormGroupDirective, NgForm } from '@angular/forms';

export type TErrorStateMatcher = (
  control: AbstractControl | null,
  form: FormGroupDirective | NgForm | null
) => boolean;
